export default "__VITE_ASSET__DisLYizi__"